module.exports = __webpack_public_path__ + "img/copy.c1137a9e.svg";